(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired3de"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired3de"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5m8ul", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $3e65976d4fe683a6$export$6503ec6e8aabbaf; }, function (v) { return $3e65976d4fe683a6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $3e65976d4fe683a6$export$f7ad0328861e2f03; }, function (v) { return $3e65976d4fe683a6$export$f7ad0328861e2f03 = v; });
var $3e65976d4fe683a6$export$6503ec6e8aabbaf;
var $3e65976d4fe683a6$export$f7ad0328861e2f03;
"use strict";
var $3e65976d4fe683a6$var$mapping = new Map();
function $3e65976d4fe683a6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$3e65976d4fe683a6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $3e65976d4fe683a6$var$resolve(id) {
    var resolved = $3e65976d4fe683a6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$3e65976d4fe683a6$export$6503ec6e8aabbaf = $3e65976d4fe683a6$var$register;
$3e65976d4fe683a6$export$f7ad0328861e2f03 = $3e65976d4fe683a6$var$resolve;

});

parcelRegister("bRBrN", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8a31b13868c43a0f$export$bdfd709ae4826697; }, function (v) { return $8a31b13868c43a0f$export$bdfd709ae4826697 = v; });
var $8a31b13868c43a0f$export$bdfd709ae4826697;
var $8a31b13868c43a0f$export$c9e73fbda7da57b6;
var $8a31b13868c43a0f$export$5a759dc7a1cfb72a;
"use strict";
var $8a31b13868c43a0f$var$bundleURL = {};
function $8a31b13868c43a0f$var$getBundleURLCached(id) {
    var value = $8a31b13868c43a0f$var$bundleURL[id];
    if (!value) {
        value = $8a31b13868c43a0f$var$getBundleURL();
        $8a31b13868c43a0f$var$bundleURL[id] = value;
    }
    return value;
}
function $8a31b13868c43a0f$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8a31b13868c43a0f$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $8a31b13868c43a0f$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8a31b13868c43a0f$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$8a31b13868c43a0f$export$bdfd709ae4826697 = $8a31b13868c43a0f$var$getBundleURLCached;
$8a31b13868c43a0f$export$c9e73fbda7da57b6 = $8a31b13868c43a0f$var$getBaseURL;
$8a31b13868c43a0f$export$5a759dc7a1cfb72a = $8a31b13868c43a0f$var$getOrigin;

});

parcelRegister("lQSqU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fe88ad92f12e1252$export$1b5e630bc3aea29f; });

var $5DJIp = parcelRequire("5DJIp");

var $EHwH4 = parcelRequire("EHwH4");

var $brahc = parcelRequire("brahc");

var $lYmBh = parcelRequire("lYmBh");
function $fe88ad92f12e1252$export$1b5e630bc3aea29f(arr) {
    return (0, $5DJIp._array_without_holes)(arr) || (0, $EHwH4._iterable_to_array)(arr) || (0, $lYmBh._unsupported_iterable_to_array)(arr) || (0, $brahc._non_iterable_spread)();
}

});
parcelRegister("5DJIp", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $41b40e61b3c2e7d5$export$7e0947b5ad3404e2; });

var $iOpQ0 = parcelRequire("iOpQ0");
function $41b40e61b3c2e7d5$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $iOpQ0._array_like_to_array)(arr);
}

});
parcelRegister("iOpQ0", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $db20f05fd1b17a20$export$79e617b1955a2616; });
function $db20f05fd1b17a20$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("EHwH4", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $07a57ff6389a3761$export$1eb58a6e75231000; });
function $07a57ff6389a3761$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("brahc", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $853a3004567883e8$export$e6f3c4780d19eb2b; });
function $853a3004567883e8$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lYmBh", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $fff0bb80e18fdf92$export$a5be06335b3a083c; });

var $iOpQ0 = parcelRequire("iOpQ0");
function $fff0bb80e18fdf92$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $iOpQ0._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $iOpQ0._array_like_to_array)(o, minLen);
}

});


parcelRegister("b4udU", function(module, exports) {


module.exports = (parcelRequire("dh5GZ"))((parcelRequire("5m8ul")).resolve("lgRqF")).then(function() {
    return parcelRequire("1IDhI");
});

});
parcelRegister("dh5GZ", function(module, exports) {
"use strict";

var $i1Eqw = parcelRequire("i1Eqw");
module.exports = $i1Eqw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("i1Eqw", function(module, exports) {
"use strict";
var $d1f7adecebf3f8c1$var$cachedBundles = {};
var $d1f7adecebf3f8c1$var$cachedPreloads = {};
var $d1f7adecebf3f8c1$var$cachedPrefetches = {};
function $d1f7adecebf3f8c1$var$getCache(type) {
    switch(type){
        case "preload":
            return $d1f7adecebf3f8c1$var$cachedPreloads;
        case "prefetch":
            return $d1f7adecebf3f8c1$var$cachedPrefetches;
        default:
            return $d1f7adecebf3f8c1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d1f7adecebf3f8c1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("igezu", function(module, exports) {


module.exports = (parcelRequire("dh5GZ"))((parcelRequire("5m8ul")).resolve("bJcEj")).then(function() {
    return parcelRequire("ju6nv");
});

});

parcelRegister("cG0UM", function(module, exports) {


module.exports = (parcelRequire("dh5GZ"))((parcelRequire("5m8ul")).resolve("1XsGd")).then(function() {
    return parcelRequire("1kI9Y");
});

});

parcelRegister("eBHoJ", function(module, exports) {


module.exports = (parcelRequire("dh5GZ"))((parcelRequire("5m8ul")).resolve("azeMj")).then(function() {
    return parcelRequire("zRHXt");
});

});

parcelRegister("94QDO", function(module, exports) {


module.exports = (parcelRequire("dh5GZ"))((parcelRequire("5m8ul")).resolve("SjGwf")).then(function() {
    return parcelRequire("2b33z");
});

});

var $cecae6df441e795b$exports = {};


(parcelRequire("5m8ul")).register((parcelRequire("bRBrN")).getBundleURL("4e6sy"), JSON.parse('["4e6sy","app.js","lgRqF","countdown.12bc024b.js","bJcEj","rsvp.e51ebf69.js","1XsGd","login.aca9b743.js","azeMj","message.7477db03.js","SjGwf","gifting.f1666a8e.js","3gCw1","app.css"]'));


var $lQSqU = parcelRequire("lQSqU");

var $816196d879a3ed9b$var$dynamicModules = (0, $lQSqU._)(document.querySelectorAll("[data-module]")).map(function(module) {
    return module.dataset.module;
});

if ($816196d879a3ed9b$var$dynamicModules.includes("countdown")) (parcelRequire("b4udU")).then(function(countdown) {
    countdown.init();
});

if ($816196d879a3ed9b$var$dynamicModules.includes("rsvp")) (parcelRequire("igezu")).then(function(rsvp) {
    rsvp.init();
});

if ($816196d879a3ed9b$var$dynamicModules.includes("login")) (parcelRequire("cG0UM")).then(function(login) {
    login.init();
});

if ($816196d879a3ed9b$var$dynamicModules.includes("message")) (parcelRequire("eBHoJ")).then(function(message) {
    message.init();
});

if ($816196d879a3ed9b$var$dynamicModules.includes("gifting")) (parcelRequire("94QDO")).then(function(gifting) {
    gifting.init();
});
if ($816196d879a3ed9b$var$dynamicModules.includes("check-saved")) {
    var $816196d879a3ed9b$var$_document_cookie_split_find;
    var $816196d879a3ed9b$var$cookieValue = ($816196d879a3ed9b$var$_document_cookie_split_find = document.cookie.split("; ").find(function(row) {
        return row.startsWith("saved=");
    })) === null || $816196d879a3ed9b$var$_document_cookie_split_find === void 0 ? void 0 : $816196d879a3ed9b$var$_document_cookie_split_find.split("=")[1];
    if (document.querySelector('[data-id="'.concat($816196d879a3ed9b$var$cookieValue, '"]'))) {
        var $816196d879a3ed9b$var$_rsvpText_dataset;
        var $816196d879a3ed9b$var$rsvpButton = document.querySelector(".js-rsvp");
        var $816196d879a3ed9b$var$rsvpText = document.querySelector(".js-rsvp-text");
        $816196d879a3ed9b$var$rsvpButton === null || $816196d879a3ed9b$var$rsvpButton === void 0 ? void 0 : $816196d879a3ed9b$var$rsvpButton.innerHTML = "Update your RSVP";
        $816196d879a3ed9b$var$rsvpText === null || $816196d879a3ed9b$var$rsvpText === void 0 ? void 0 : $816196d879a3ed9b$var$rsvpText.innerHTML = ($816196d879a3ed9b$var$_rsvpText_dataset = $816196d879a3ed9b$var$rsvpText.dataset) === null || $816196d879a3ed9b$var$_rsvpText_dataset === void 0 ? void 0 : $816196d879a3ed9b$var$_rsvpText_dataset.alt;
    }
}

})();
//# sourceMappingURL=app.js.map
